import { isFiniteNumber } from '@/utils/math-kit';

/** 将 Markup 背景圆角限制在背景高度的一半以内。 */
export function clampMarkupLabelRoundWeight(roundWeight: number, backgroundHeight: number) {
    if (!isFiniteNumber(roundWeight) || !isFiniteNumber(backgroundHeight) || backgroundHeight <= 0) return 0;
    return Math.min(Math.max(roundWeight, 0), backgroundHeight / 2);
}
